import React, { useState } from 'react';
import useFirestore from '../../hooks/useFirestore';
import { updateItem } from '../../firebase/firestore';
import Table from '../../components/Table/Table';
import Modal from '../../components/Modal/Modal';
import styles from './Orders.module.css';

const statusLabels = {
  pending: 'قيد الانتظار',
  shipped: 'تم الشحن',
  delivered: 'تم التسليم',
};

const statusClass = {
  pending: 'pending',
  shipped: 'shipped',
  delivered: 'delivered',
};

export default function Orders() {
  const { data: orders, loading } = useFirestore('orders');
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleStatusChange = async (id, status) => {
    await updateItem('orders', id, { status });
    setSelectedOrder((prev) => (prev ? { ...prev, status } : prev));
  };

  const columns = [
    { key: 'id', label: 'رقم الطلب', render: (row) => <span className="nums">#{row.id.slice(0, 6)}</span> },
    { key: 'customerName', label: 'العميل' },
    { key: 'total', label: 'الإجمالي', render: (row) => <span className="nums">{row.total} ج.م</span> },
    {
      key: 'status',
      label: 'الحالة',
      render: (row) => (
        <span className={`${styles.status} ${styles[statusClass[row.status] || 'pending']}`}>
          {statusLabels[row.status] || 'قيد الانتظار'}
        </span>
      ),
    },
    {
      key: 'actions',
      label: '',
      render: (row) => (
        <button className={styles.viewBtn} onClick={() => setSelectedOrder(row)}>عرض التفاصيل</button>
      ),
    },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>الطلبات</h2>
        <p>متابعة وإدارة طلبات العملاء ({orders.length} طلب)</p>
      </div>

      <Table columns={columns} data={orders} loading={loading} emptyText="لا توجد طلبات حتى الآن" />

      <Modal
        isOpen={!!selectedOrder}
        onClose={() => setSelectedOrder(null)}
        title={selectedOrder ? `تفاصيل الطلب #${selectedOrder.id.slice(0, 6)}` : ''}
      >
        {selectedOrder && (
          <div className={styles.details}>
            <div className={styles.detailRow}>
              <span>العميل</span>
              <strong>{selectedOrder.customerName}</strong>
            </div>
            <div className={styles.detailRow}>
              <span>الإجمالي</span>
              <strong className="nums">{selectedOrder.total} ج.م</strong>
            </div>
            <div className={styles.detailRow}>
              <span>ملاحظات</span>
              <strong>{selectedOrder.notes || '—'}</strong>
            </div>

            <div className={styles.statusPicker}>
              <p>تحديث الحالة</p>
              <div className={styles.statusButtons}>
                {Object.entries(statusLabels).map(([key, label]) => (
                  <button
                    key={key}
                    onClick={() => handleStatusChange(selectedOrder.id, key)}
                    className={
                      selectedOrder.status === key
                        ? `${styles.statusBtn} ${styles.statusBtnActive}`
                        : styles.statusBtn
                    }
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
